
import defaultImage from './avatar.svg'
import md5 from 'md5'

import { createAvatar } from './lettered'

export default {
  name: 'VsAvatar',
  props: {
    size: {
      type: [String, Object],
      default: 'sm'
    },
    type: {
      type: String,
      default: 'gravatar'
    },
    name: {
      type: String,
      default: null
    },
    email: {
      type: String,
      default: null
    },
    position: {
      type: String,
      validator: value => ['left', 'right'].includes(value),
      default: 'left'
    },
    source: {
      type: String,
      default: null
    },
    shape: {
      type: String,
      validator: value => ['circle', 'square', 'radius'].includes(value),
      default: 'circle'
    },
    label: {
      type: [Boolean, String],
      default: null
    }
  },
  vessel: {
    avatar: {
      overflow: 'hidden',
      $size: 'height',
      $label: {
        marginLeft(val) {
          return this.marginFor('right', val)
        },
        marginRight(val) {
          return this.marginFor('left', val)
        }
      },
      $shape: {
        borderRadius(val) {
          const options = {
            square: 'none',
            circle: 'full',
            radius: true
          }

          return options[val]
        }
      }
    }
  },
  computed: {
    defaultImage() {
      return defaultImage
    },
    defaultLabel() {
      return this.label ? this.label : (this.email || this.name)
    },
    showLabel() {
      return this.label != false
    },
    showName() {
      return this.email && this.name && this.name != this.defaultLabel
    },
    flexDirection() {
      return this.position == 'left' ? 'row' : 'row-reverse'
    },
    gravatar() {
      let image = null

      if (this.email && this.type == 'gravatar') {
        const hash = md5(this.email.trim().toLowerCase())
        image = `//www.gravatar.com/avatar/${hash}?s=96&d=mm&r=PG`
      } else if (this.name) {
        image = createAvatar(this.name, { twoLetter: true })
      }

      return image || this.defaultImage
    }
  },
  methods: {
    marginFor(position, val) {
      return val != false && this.position == position ? 'xs' : null
    }
  }
}
